<mat-accordion>
  <mat-expansion-panel [expanded]="true" (opened)="explansionPanelState = true">

    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="header">
          <i class="cml-fw cml-lg cml-archive" [attr.active-color]="'cml-active-red'"></i>Definice výkazu účetní jednotky
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-container form">

      <div class="navigate-buttons">
        <button mat-button (click)="newDefiniceModal()">
          <i class="cml-fw cml-lg cml-plus" [attr.active-color]="'cml-active-blue'">
          </i>
            <span>Importovat definici výkazu</span>
        </button>

        <button mat-button (click)="copyDefinice()">
          <i class="cml-fw cml-lg cml-copy" [attr.active-color]="'cml-active-black'">
          </i>
          <span>Kopírovat z jiné UJ</span>
        </button>

        <button mat-button (click)="navigateToFormat()">
          <i class="cml-fw cml-lg cml-schedule" [attr.active-color]="'cml-active-purple'"></i>
          <span>Formáty výkazu</span>
        </button>
      </div>

      <div class="scroll">
        <table *ngIf="dataSource.length > 0" mat-table [dataSource]="dataSource" class="mat-elevation-z1">

          <ng-container *ngFor="let col of tableColumns" matColumnDef="{{col.name}}">
            <th mat-header-cell *matHeaderCellDef> {{col.title}} </th>

            <span *ngIf="col.type == 'date'">
              <td mat-cell *matCellDef="let element" [matTooltip]="element[col.name] | czDatePipe" matTooltipShowDelay="1000" matTooltipPosition="above">
                {{element[col.name] | czDatePipe}}
              </td>
            </span>

            <span *ngIf="col.type == 'boolean'">
              <td mat-cell *matCellDef="let element" [matTooltip]="element[col.name] | booleanPipe" matTooltipShowDelay="1000" matTooltipPosition="above">
                {{element[col.name] | booleanPipe}}
              </td>
            </span>

            <span *ngIf="col.type == ''">
              <td mat-cell *matCellDef="let element" [matTooltip]="element[col.name]" matTooltipShowDelay="1000" matTooltipPosition="above">
                {{element[col.name]}}
              </td>
            </span>
          </ng-container>

          <ng-container matColumnDef="editAction">
            <th mat-header-cell *matHeaderCellDef ></th>
            <td mat-cell *matCellDef="let i = index">
              <button mat-button (click)="openEditDefinice(i)"><i class="cml-fw cml-lg cml-edit-pen" [attr.active-color]="'cml-active-black'"></i></button>
            </td>
          </ng-container>

          <ng-container matColumnDef="deleteAction">
            <th mat-header-cell *matHeaderCellDef ></th>
            <td mat-cell *matCellDef="let i = index">
              <button mat-button (click)="deleteVykaz(i)"><i class="cml-fw cml-lg cml-trash-o" [attr.active-color]="'cml-active-black'"></i></button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr class="tbody-row" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
    <mat-hint class="mat-hint-empty-data" *ngIf="dataSource.length <= 0">UJ neobsahuje žádné definice výkazu</mat-hint>
  </mat-expansion-panel>
</mat-accordion>
